import PageHeader from "components/Molecules/Products/AddProduct/header";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomAccordion from "components/Molecules/Accordion/customAccordion";

export default function EditVendorTemplate({ breadcrumbs, data, type }) {
  const { t } = useTranslation();
  const [expandedAccordion, setExpandedAccordion] = useState(null);

  // console.log("title type is",type);
  return (
    <>
      <PageHeader
        title={
          type === "edit" ? t("vendors.edit_vendor") : t("vendors.add_vendor")
        }
        breadcrumbs={breadcrumbs}
      />
      <CustomAccordion
        expandedAccordion={expandedAccordion}
        setExpandedAccordion={setExpandedAccordion}
        data={data}
      />
    </>
  );
}
